import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly loading = new BehaviorSubject<boolean>(false);
  private pending = 0;

  readonly isLoading$: Observable<boolean> = this.loading.asObservable();

  get pendingRequests(): number {
    return this.pending;
  }

  showLoader(): void {
    this.pending += 1;
    this.emit();
  }

  hideLoader(): void {
    this.pending = Math.max(0, this.pending - 1);
    this.emit();
  }

  forceHide(): void {
    this.pending = 0;
    this.emit();
  }

  private emit(): void {
    const next = this.pending > 0;
    if (this.loading.value !== next) {
      this.loading.next(next);
    }
  }
}
